import { PropsWithChildren } from 'react';
import IfEmbed from './IfEmbed';

const IfNotEmbed = ({ children }: PropsWithChildren<{}>) => <IfEmbed not>{children}</IfEmbed>;

export default IfNotEmbed;
